module.exports = __webpack_public_path__ + "assets/tornado.ef5db3fa.svg";